// The SHIFT+? dev dialog (FeatureFlagModal.tsx) derives its list from this enum,
// so adding a flag here surfaces it there automatically — no manual sync needed.
export enum FeatureFlag {
  /** Permanent (for now) */
  CoinList = 'CoinList' /** Only exists for Drescher */,
  DevTools = 'DevTools',

  /** Feature flag to be enabled to HIDE the feature (inverted semantics) */
  HideCashManagementDeposit = 'HideCashManagementDeposit',
  HideCashManagementTransfer = 'HideCashManagementTransfer',
  HidePliantReferenceInLinkSelector = 'HidePliantReferenceInLinkSelector',
  HidePliantReferenceInOverview = 'HidePliantReferenceInOverview',
  AccountingPaymentsNew = 'AccountingPaymentsNew' /** Keep for Caritas until autumn */,
  dev_ServiceProviderApp = 'dev_ServiceProviderApp' /** Keep for Caritas until autumn */,

  /** Development */
  dev_CaritasManualRoles = 'dev_CaritasManualRoles',

  /** Feature to be removed (Keep for Drescher) */
  AccountingPayments = 'AccountingPayments',

  dev_ResidentTypeSelector = 'dev_ResidentTypeSelector',
  dev_InitialBalanceForResident = 'dev_InitialBalanceForResident',
  dev_NationalityAndCountryOfResidenceSelectors = 'dev_NationalityAndCountryOfResidenceSelectors',

  dev_OfflineSepaMandate = 'dev_OfflineSepaMandate',
  dev_OfflineSepaManualPayin = 'dev_OfflineSepaManualPayin',
  dev_UnassignPliantTransaction = 'dev_UnassignPliantTransaction',

  /** Expense management */
  ExpenseManagement = 'ExpenseManagement',
  ReceiptManagement = 'ReceiptManagement',
  ReceiptImageAnalysis = 'ReceiptImageAnalysis',
  ReceiptDocumentScanner = 'ReceiptDocumentScanner',

  /** Caritas Hauptkasse-prompt on Adjustment cash transaction groups */
  MainCashboxAdjustmentFlag = 'MainCashboxAdjustmentFlag',

  /**
   * Scope selector tabs. Tenant level only — an NH-level override would make
   * the tabs appear and disappear as the user switches homes.
   */
  dev_LegalEntityScope = 'dev_LegalEntityScope',
  dev_TenantScope = 'dev_TenantScope',

  /** "Mismatch risk" tab in the cash transaction group list */
  MismatchRiskTab = 'MismatchRiskTab',

  /** Reporting section with balance changes per cash list and Pliant */
  dev_ReportingV3 = 'dev_ReportingV3',

  /** Legal entity KYC banner and hosted IDV dialog. Tenant level only, like the scope tabs. */
  dev_LegalEntityHostedIdv = 'dev_LegalEntityHostedIdv',

  /** Finance overview PDF for a picked date, institution cash list only */
  dev_FinanceOverviewPdfAtDate = 'dev_FinanceOverviewPdfAtDate',
}

// Flags read from the tenant only, never from the selected nursing home.
export const tenantOnlyFeatureFlags: readonly FeatureFlag[] = [
  FeatureFlag.dev_LegalEntityScope,
  FeatureFlag.dev_TenantScope,
  FeatureFlag.dev_LegalEntityHostedIdv,
];

export enum FeatureFlagStatus {
  Disabled,
  Enabled,
}
